import React from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import appStoreImg from "../assets/img/app-store.png";
import googlePlayImg from "../assets/img/google.store.png";
import { trackAppStoreClick, trackGooglePlayClick } from "../analytics/googleAnalytics";
import "./MoneyPages.css";

export default function AlternativeMyFitnessPal() {
  return (
    <>
      <Helmet>
        <title>Alternativa a MyFitnessPal Gratis en 2026 | Wayo - Sin Registro Manual</title>
        <meta
          name="description"
          content="¿Cansado de buscar alimentos en MyFitnessPal? Wayo reconoce tu plato con una foto. La alternativa a MyFitnessPal más rápida para comida española. Gratis."
        />
        <meta
          name="keywords"
          content="alternativa myfitnesspal, app mejor que myfitnesspal, alternativa a myfitnesspal, myfitnesspal alternativa, sustituir myfitnesspal, app contar calorias sin registro"
        />
        <meta name="robots" content="index, follow, max-image-preview:large" />
        <link rel="canonical" href="https://wayoai.app/alternativa-myfitnesspal" />
      </Helmet>

      <main className="money-page">
        <Header />
        <div className="money-shell">
          <section className="money-hero">
            <div className="money-copy">
              <span className="money-badge">Alternativa a MyFitnessPal</span>
              <h1>Menos búsqueda manual. Más comida real.</h1>
              <p>
                Si estás cansado de MyFitnessPal, normalmente no buscas más botones. Buscas
                <strong> menos fricción</strong>, una app más rápida y una forma más natural de registrar
                lo que comes de verdad.
              </p>

              <div className="money-highlights">
                <div className="money-highlight">
                  <span>📸</span>
                  <div>
                    <strong>Registra con foto</strong>
                    <span>Mucho mejor para platos caseros y comidas mezcladas.</span>
                  </div>
                </div>
                <div className="money-highlight">
                  <span>⚡</span>
                  <div>
                    <strong>Menos pasos</strong>
                    <span>Ideal si abandonas el conteo porque te da pereza registrar todo.</span>
                  </div>
                </div>
                <div className="money-highlight">
                  <span>🥗</span>
                  <div>
                    <strong>Pensada para comida real</strong>
                    <span>No dependes solo de productos envasados y códigos de barras.</span>
                  </div>
                </div>
              </div>

              <div className="money-store-row">
                <a
                  className="money-store-badge"
                  href="https://apps.apple.com/app/id6756500478"
                  onClick={() => trackAppStoreClick("alt_myfitnesspal_hero")}
                >
                  <img src={appStoreImg} alt="Descargar Wayo en App Store" />
                </a>
                <a
                  className="money-store-badge"
                  href="https://play.google.com/store/apps/details?id=com.facundosolis.wayo"
                  onClick={() => trackGooglePlayClick("alt_myfitnesspal_hero")}
                >
                  <img src={googlePlayImg} alt="Descargar Wayo en Google Play" />
                </a>
              </div>
              <p className="money-note">Prueba gratis y compara por ti mismo qué tan rápido registras.</p>
            </div>

            <div className="money-visual">
              <span className="money-score">Comparativa práctica 2026</span>
              <div className="money-visual-card">
                <h3>Lo que más empuja a la gente a cambiar</h3>
                <ul>
                  <li>Tener que buscar alimento por alimento</li>
                  <li>Mucho tiempo perdido en cada comida</li>
                  <li>Poca comodidad con platos caseros o de restaurante</li>
                  <li>Demasiada fricción para mantener el hábito semanas seguidas</li>
                </ul>
              </div>

              <div className="money-mini-grid">
                <div className="money-mini-card">
                  <strong>+rápido</strong>
                  <span>Registro más ligero y natural para el día a día.</span>
                </div>
                <div className="money-mini-card">
                  <strong>+real</strong>
                  <span>Mejor encaje con comida casera y platos no envasados.</span>
                </div>
              </div>
            </div>
          </section>

          <div className="money-sections">
            <section className="money-section">
              <h2>Por qué tanta gente busca una alternativa a MyFitnessPal</h2>
              <p>
                MyFitnessPal sigue siendo una referencia, pero la queja más repetida es casi siempre la misma:
                <strong> registrar todo da demasiada pereza</strong>. Cuando el conteo se vuelve pesado, la adherencia
                cae. Y si no mantienes el hábito, da igual la base de datos que tengas.
              </p>
              <ul>
                <li>Mucho clic para una sola comida</li>
                <li>Peor experiencia con platos caseros</li>
                <li>Más cómoda para productos con código de barras que para comida real</li>
                <li>Acabas abandonando aunque al principio empieces motivado</li>
              </ul>
            </section>

            <section className="money-section">
              <h2>Wayo vs MyFitnessPal</h2>
              <table className="money-table">
                <thead>
                  <tr>
                    <th>Aspecto</th>
                    <th>MyFitnessPal</th>
                    <th>Wayo</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Registro de comida</td>
                    <td>Muy basado en búsqueda manual y barras</td>
                    <td>Más orientado a foto, rapidez y menos fricción</td>
                  </tr>
                  <tr>
                    <td>Comida casera</td>
                    <td>Menos cómoda</td>
                    <td>Mucho más natural para platos reales</td>
                  </tr>
                  <tr>
                    <td>Curva de uso</td>
                    <td>Más clásica y manual</td>
                    <td>Más simple para empezar</td>
                  </tr>
                  <tr>
                    <td>Ideal para</td>
                    <td>Usuarios que viven en la base de datos</td>
                    <td>Usuarios que quieren registrar sin cansarse</td>
                  </tr>
                </tbody>
              </table>
            </section>

            <section className="money-cta">
              <h3>¿La diferencia? Que la sigas usando dentro de 3 semanas.</h3>
              <p>
                La mejor alternativa a MyFitnessPal no es la que más promete, sino la que te hace más fácil
                mantener el hábito.
              </p>
              <div className="money-store-row">
                <a
                  className="money-store-badge"
                  href="https://apps.apple.com/app/id6756500478"
                  onClick={() => trackAppStoreClick("alt_myfitnesspal_mid")}
                >
                  <img src={appStoreImg} alt="Descargar Wayo en App Store" />
                </a>
                <a
                  className="money-store-badge"
                  href="https://play.google.com/store/apps/details?id=com.facundosolis.wayo"
                  onClick={() => trackGooglePlayClick("alt_myfitnesspal_mid")}
                >
                  <img src={googlePlayImg} alt="Descargar Wayo en Google Play" />
                </a>
              </div>
            </section>

            <section className="money-section">
              <h2>Qué alternativa te conviene según tu perfil</h2>
              <ul>
                <li><strong>Quiero registrar más rápido:</strong> Wayo</li>
                <li><strong>Quiero una base de datos gigante:</strong> MyFitnessPal sigue siendo fuerte</li>
                <li><strong>Quiero plan gratis muy generoso:</strong> FatSecret</li>
                <li><strong>Quiero precisión muy técnica:</strong> Cronometer</li>
              </ul>
              <div className="money-inline-links">
                <Link to="/blog/mejores-alternativas-a-myfitnesspal-2026">Ver comparativa completa</Link>
                <Link to="/app-para-contar-calorias-con-foto">Ver app con foto</Link>
                <Link to="/blog/mejores-apps-para-contar-macros-2026">Ver apps para macros</Link>
              </div>
            </section>

            <section className="money-section">
              <h2>Preguntas frecuentes</h2>
              <div className="money-faq-grid">
                <div className="money-faq-item">
                  <h3>¿Wayo sustituye a MyFitnessPal?</h3>
                  <p>Sí si tu prioridad es registrar más rápido y depender menos del registro manual clásico.</p>
                </div>
                <div className="money-faq-item">
                  <h3>¿Va mejor con comida casera?</h3>
                  <p>Ese es uno de sus puntos fuertes: reducir fricción con platos reales, no solo productos de supermercado.</p>
                </div>
                <div className="money-faq-item">
                  <h3>¿Sirve también para macros?</h3>
                  <p>Sí. Puedes usarlo tanto para calorías como para seguir proteínas, carbohidratos y grasas.</p>
                </div>
              </div>
            </section>
          </div>
        </div>
        <Footer />
      </main>
    </>
  );
}
